module.exports = __webpack_public_path__ + "img/Signature.c8ccd19e.png";